export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const FETCH_USER = 'FETCH_USER';

export const CLEAR_USER_ACTION = 'CLEAR_USER_ACTION';
export const CLEAR_USER = 'CLEAR_USER';
